export default __webpack_public_path__ + "static/toalla-67d1da5272236be58b28b72d49698930.png";